import { render, staticRenderFns } from "./PlatMatchingOrder.vue?vue&type=template&id=2f6064d3&"
import script from "./PlatMatchingOrder.vue?vue&type=script&lang=js&"
export * from "./PlatMatchingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports